/* Solution adapted from http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript */

/* Parameters:
  decimalPlaces   <int>: the number of places to pad after the decimal place (default 2)
  decimalChar  <string>: the character string to use for the decimal place (default '.')
  groupingChar <string>: the character string to use for grouping numbers over 1000 (default ',')
*/

/* Usage: 
  import {formatCurrency} from './formatCurrency';
  
  Number.prototype.formatCurrency = formatCurrency;

  (1234).formatCurrency();
  myNumber.formatCurrency();
*/

export const formatCurrency = function (decimalPlaces, decimalChar, groupingChar) {
    let value = this;

    decimalPlaces = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces;
    decimalChar = decimalChar == undefined ? '.' : decimalChar;
    groupingChar = groupingChar == undefined ? ',' : groupingChar;

    let sign = value < 0 ? '-' : '';
    let decimalValue = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(decimalPlaces)));
    let group = (group = decimalValue.length) > 3 ? group % 3 : 0;
   
   return sign + (group ? decimalValue.substr(0, group) + groupingChar : '') 
            + decimalValue.substr(group).replace(/(\d{3})(?=\d)/g, `$1${groupingChar}`)
            + (decimalPlaces ? decimalChar + Math.abs(value - decimalValue).toFixed(decimalPlaces).slice(2) : '');
};



// WEBPACK FOOTER //
// ./src/features/shared/util/formatCurrency.js